module.exports = __webpack_public_path__ + "img/title.d4c857c4.png";